import classNames from 'classnames';

import emptyIcon from '../../../assets/img/icon-no-referrals.svg';
import { GlobalClassesEnum } from '../../../assets/scss/globalClasses/globalClasses.constants';

import styles from './ReferralsEmptyState.module.scss';

type Props = {
  title: string;
  description: string;
};

const ReferralsEmptyState = ({ title, description }: Props) => (
  <div className={styles.wrapper}>
    <img className={styles.icon} src={emptyIcon} alt="" />
    <div className={GlobalClassesEnum.CommonBody1Text}>{title}</div>
    <div
      className={classNames(
        GlobalClassesEnum.CommonBody2Text,
        GlobalClassesEnum.CommonTextSecondary,
        styles.description,
      )}
    >
      {description}
    </div>
  </div>
);

export default ReferralsEmptyState;
